import { JsonObject } from 'json2typescript';
import { FundingDataInterface } from '../interfaces/funding-data.interface';

@JsonObject('FundingData')
export class FundingData implements FundingDataInterface {
  BankName?: string;
  CashAmount?: number;
  CashCurrency?: string;
  FundTransfers?: any[];
  ModelPortfolioCode?: string;
  PayeeDeliveryCode?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
